<template>
  <div>
    <div class="mb-2">
      <SearchTabs @change="searchTabChange" />
    </div>
    <div v-if="searchTabValue == 'A'">
      <OrderFiles
        v-if="isVc === 'Y'"
        class="mb-4"
        :amzReplenishmentCode="amzReplenishmentCode"
        :disabled="disabled"
      />

      <div class="d-flex">
        <div class="side-frame-success" style="margin-bottom: 0;"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            No：{{ formData.amzReplenishmentNo || '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.amzPeriodTitle || '' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <el-tag
            size="mini"
            :type="
              formData.replenishmentStatus === 'N'
                ? 'primary'
                : formData.replenishmentStatus === 'D'
                ? 'danger'
                : formData.replenishmentStatus === 'P'
                ? 'warning'
                : formData.replenishmentStatus === 'Y'
                ? 'success'
                : formData.replenishmentStatus === 'S'
                ? 'logistics'
                : 'info'
            "
          >
            {{ formData.v_replenishmentStatus }}
          </el-tag>
          <el-divider direction="vertical"></el-divider>
          <el-tag
            v-if="formData.v_skuSalesChannel"
            size="mini"
            :type="
              formData.skuSalesChannel === 'F'
                ? 'success'
                : formData.skuSalesChannel === 'V'
                ? 'warning'
                : ''
            "
          >
            {{ formData.v_skuSalesChannel }}
          </el-tag>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Update：{{ formData.modifyByName || '--' }} at
            {{ formData.modifyDate || '--' }}
          </span>
        </div>
      </div>
      <SkuTable
        v-if="formData.amzReplenishmentNo"
        :amzReplenishmentCode="amzReplenishmentCode"
        :disabled="disabled"
        :isVc="isVc"
      />
    </div>
    <div v-if="searchTabValue == 'B'">
      <Promotion
        :amzReplenishmentCode="amzReplenishmentCode"
        :disabled="disabled"
      ></Promotion>
    </div>
  </div>
</template>
<script>
import OrderFiles from '../order-files'
import SkuTable from '../sku-table'
import Promotion from '../promotion'
import SearchTabs from './search-tabs'
export default {
  components: { OrderFiles, SkuTable, SearchTabs, Promotion },
  props: {
    amzReplenishmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { formData: {}, searchTabValue: 'A' }
  },
  computed: {
    isVc() {
      const { skuSalesChannel } = this.formData
      return skuSalesChannel == 'V' ? 'Y' : 'N'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    searchTabChange(e) {
      this.searchTabValue = e
    },
    async getData() {
      if (!this.amzReplenishmentCode) return
      const params = { amzReplenishmentCode: this.amzReplenishmentCode }
      const res = await this.$api
        .ecomAmzReplenishmentDetailApi(params)
        .catch(() => null)
      this.formData = res?.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
